/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderContentType } from './orderContentType';
import { AssessmentResult } from './assessmentResult';
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface FinishedOrderApiModel { 
    orderId: number;
    orderNumber: string;
    orderType: AssessmentTypeEnum;
    orderContentType: OrderContentType;
    createDate: string;
    issueDate: string;
    employeeTitleBeforeName: string;
    employeeName: string;
    employeeSurname: string;
    employeeTitleAfterName: string;
    employeePersonalNumber: string;
    providerId?: number | null;
    providerName?: string | null;
    orderResultStatus: AssessmentResult;
}
export namespace FinishedOrderApiModel {
}


